import { parseISO, format } from 'date-fns'
import i18n from 'i18n'
import localeEnUs from 'date-fns/locale/en-US'
import localeEs from 'date-fns/locale/es'
import localeFr from 'date-fns/locale/fr'
import localePt from 'date-fns/locale/pt-BR'

export const dateParse = (
  date: string | Date | undefined,
  defaultFormat = 'dd/MM/yyyy'
) => {
  const label = 'commons.not.date'
  try {
    if (typeof date === 'string') {
      const parse = parseISO(date)
      return format(parse, defaultFormat, { locale: getLanguage() })
    } else {
      return label
    }
  } catch (error) {
    return label
  }
}

export const getLanguage = () => {
  switch (i18n.language) {
    case 'es':
      return localeEs
    case 'en':
      return localeEnUs
    case 'fr':
      return localeFr
    case 'Pt':
      return localePt
    default:
      return localeEnUs
  }
}
